/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * TOO_FEW_ANSWERS — fewer than two answers. NO_CORRECT_ANSWER — no answer on a green background. UNKNOWN_POSITION — a marked column whose position has no code in jAIn the conversion knows, or one the dictionary does not have active. NO_POSITION — no column of a position the conversion knows is marked for the question, so stanowiska stays empty, which the import does not take. NO_SOURCE — the source is empty. UNKNOWN_SOURCE — a source not on the list. PROCEDURE_WITHOUT_NAME — a procedure, but not which one. UNREADABLE_ROW — a row that is neither a question, with a number in NR, nor an answer under one, with a letter.
 * @export
 * @enum {string}
 */

export const ConversionProblemCodeDto = {
    TooFewAnswers: 'TOO_FEW_ANSWERS',
    NoCorrectAnswer: 'NO_CORRECT_ANSWER',
    UnknownPosition: 'UNKNOWN_POSITION',
    NoPosition: 'NO_POSITION',
    NoSource: 'NO_SOURCE',
    UnknownSource: 'UNKNOWN_SOURCE',
    ProcedureWithoutName: 'PROCEDURE_WITHOUT_NAME',
    UnreadableRow: 'UNREADABLE_ROW'
} as const;

export type ConversionProblemCodeDto = typeof ConversionProblemCodeDto[keyof typeof ConversionProblemCodeDto];



